import React from "react";

const SectionHead = ({
  number,
  title,
  emphasis,
  id,
}: {
  number: string;
  title: string;
  emphasis: string;
  id: string;
}) => (
  <div className="section-head">
    <span className="section-num">{number}</span>
    <h2 className="section-title" id={id}>
      {title} <em>{emphasis}</em>
    </h2>
  </div>
);

export default SectionHead;
